import { render, staticRenderFns } from "./MyMenu.vue?vue&type=template&id=c789e42c&scoped=true&"
import script from "./MyMenu.vue?vue&type=script&lang=js&"
export * from "./MyMenu.vue?vue&type=script&lang=js&"
import style0 from "./MyMenu.vue?vue&type=style&index=0&id=c789e42c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c789e42c",
  null
  
)

export default component.exports